export default __webpack_public_path__ + "static/media/ev1.8cc182f5.svg";